const ContainerRegular = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 80 80"
		fill="none"
		{...props}
	>
		<g clipPath="url(#a)">
			<path d="M15.922 51.063c.61 0 1.094-.485 1.094-1.094V36.062c0-.609-.485-1.093-1.094-1.093-.61 0-1.094.484-1.094 1.093V49.97c0 .61.485 1.093 1.094 1.093ZM7.64 50.188c.61 0 1.094-.485 1.094-1.094V36.937c0-.609-.484-1.093-1.093-1.093-.61 0-1.094.484-1.094 1.093v12.157c0 .61.484 1.093 1.094 1.093ZM27.656 58.64c.203.172.453.266.719.266h.14l44.75-5.656c.547-.063.954-.531.954-1.078V33.875c0-.547-.406-1.016-.953-1.078l-44.75-5.656a1.138 1.138 0 0 0-.86.265c-.234.203-.375.5-.375.828v29.61c0 .312.14.61.375.828v-.031ZM69.36 34.485l2.672.344v16.36l-2.672.343V34.484Zm-5.734-.718 3.547.453v17.593l-3.547.454v-18.5Zm-5.719-.72 3.532.454v19.047L57.906 53V33.047Zm-5.734-.718 3.531.453v20.485l-3.531.453v-21.39Zm-5.719-.734 3.531.453v21.937l-3.53.453V31.595Zm-5.734-.719 3.531.453v23.39l-3.531.454V30.875ZM35 30.156l3.547.453v24.828L35 55.892V30.156Zm-5.531-.703 3.343.422v26.281l-3.343.422V29.453Z" />
			<path d="m78.016 29.047-.22-.125-5.968-.75h.031c0 .016-11.078-1.375-11.078-1.375l-3.812-.5-30.36-3.828c-1.5-.375-2.453-.406-3.093-.235-.391.266-21.485 4.532-21.485 4.532a1.108 1.108 0 0 0-.625.984v30.516c0 .515.36.968.875 1.078l21.5 4.5c.078 0 .157.015.219.015h.14l53.5-6.765c.547-.063.954-.531.954-1.078V30c0-.406-.219-.765-.578-.969v.016ZM10.594 58.844l-7-1.469V28.641l7-1.469v31.672Zm12.312 2.594-10.125-2.125V26.719l10.125-2.125v36.844Zm53.5-6.391-51.312 6.484V24.485l51.312 6.484v24.078Z" />
			<path
				fillRule="evenodd"
				d="M62 36a18 18 0 1 0 0-36 18 18 0 0 0 0 36Zm-.464-10.72 10-12-3.072-2.56-8.6 10.318-4.45-4.452-2.828 2.828 6 6 1.548 1.548 1.402-1.682Z"
				clipRule="evenodd"
			/>
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M0 0h80v80H0z" />
			</clipPath>
		</defs>
	</svg>
);
export default ContainerRegular;
